import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { fetchRecentActivityLogs } from '../../actions'
import { selectRecentActivityLogs } from '../../selectors'
import { Spin } from 'antd'

import { Title, ActivityList, ActivityItem, DateText, RecentActivityContainer, LoadingContainer } from './style'





const RecentActivity = () => {
  const activityLogs = useSelector(selectRecentActivityLogs)
  const loading = useSelector(state => state.SubscribedInstitutes.loading)

  const formatText = (text) => {
    return text.split(/(".*?")/).map((part, index) => {
      if (part.startsWith('"') && part.endsWith('"')) {
        // Remove quotes and wrap in strong tag
        return <strong key={index}>{part.slice(1, -1)}</strong>
      }
      return part
    })
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString)
    return date.toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true // This enables AM/PM format
    })
  }

  if (loading) {
    return (
      <RecentActivityContainer>
        <Title>Last 5 recent activity</Title>
        <LoadingContainer>
          <Spin />
        </LoadingContainer>
      </RecentActivityContainer>
    )
  }

  return (
    <RecentActivityContainer>
      <Title>Last 5 recent activity</Title>
      <ActivityList>
        {activityLogs.map((activity, index) => (
          <ActivityItem key={index}>
             <div>{formatText(activity.target)}</div>
             
            <DateText>{formatDate(activity.createdAt)}</DateText>
          </ActivityItem>
        ))}
      </ActivityList>
    </RecentActivityContainer>
  )
}

export default RecentActivity